export default __webpack_public_path__ + "static/media/SEC2030.34I-42171_-25365_0.6323efd0.jpg";